import { ITable } from '../ApiManager';
import { IAnimal } from '../DexieDB/modules/animals/entities/IAnimal';
import { getYear } from 'date-fns';

export async function FiltrosValidosCriadosOffline(
  animal: IAnimal,
  db: ITable,
) {
  const filtrosValidosArray = await db.filtrosValidos
    .where('id')
    .equals(animal.propriedade_id)
    .toArray();

  const filtrosValidos = filtrosValidosArray[0];

  const data_de_nascimento = new Date(animal.data_de_nascimento);
  const ano = getYear(data_de_nascimento);

  filtrosValidos.datas_de_nascimento.push(ano);

  if (animal.categoria) {
    filtrosValidos.categorias.push(animal.categoria);
  }
  if (animal.lote) {
    filtrosValidos.lotes.push(animal.lote);
  }
  if (animal.raca) {
    filtrosValidos.racas.push(animal.raca);
  }
  if (animal.safra) {
    filtrosValidos.safras.push(animal.safra);
  }

  await db.filtrosValidos.put(filtrosValidos, animal.propriedade_id);
}
